export enum ClusteringOwnerType {
  TEMPLATE = 'TEMPLATE',
  PROJECT = 'PROJECT',
  DRAFT = 'DRAFT'
}
